
(function () {
  'use strict';

  /* ── STATE ─────────────────────────────────────────────────── */
  var state = {
    board: 'horizontal',
    accessories: {}
  };

  var BOARDS = {
    horizontal: { name: 'Horizontal Pegboard (120 × 80 cm)', price: 16500, img: 'https://lilaworld.in/cdn/shop/files/Lila_Products_HorizontalSlotboard.jpg?v=1754402186' },
    vertical:   { name: 'Vertical Pegboard (84 × 120 cm)',   price: 18000, img: 'https://lilaworld.in/cdn/shop/products/VerticalBackboard.jpg?v=1754402142' }
  };

  var ACCESSORIES = {
    'art-desk':     { name: 'Art Desk',                price: 14500 },
    'paper-roll':   { name: 'Paper Roll Holder',       price: 2500  },
    'paper-tray':   { name: 'Paper Tray',              price: 3500  },
    'cup-holder':   { name: 'Cup Holder with Cups',    price: 3000  },
    'display-rack': { name: 'Display Rack',            price: 1500  },
    'magnet-board': { name: 'Magnet Board',            price: 2100  },
    'bookend':      { name: 'Bookend',                 price: 500   },
    'storage-bin':  { name: 'Storage Bin',             price: 1700  },
    'shelf':        { name: 'Shelf',                   price: 5500  },
    'coat-hook':    { name: 'Coat Hook',               price: 500   },
    'metal-hooks':  { name: 'Metal Hooks',             price: 500   },
    'mirror':       { name: 'Mirror',                  price: 3900  }
  };

  var BUNDLES = {
    artist:    { board: 'horizontal', accs: ['paper-roll','cup-holder','paper-tray'] },
    study:     { board: 'horizontal', accs: ['bookend','display-rack','magnet-board','paper-tray'] },
    organised: { board: 'vertical',   accs: ['shelf','storage-bin','coat-hook','metal-hooks'] }
  };

  /* ── HELPERS ───────────────────────────────────────────────── */
  function fmt(n) { return '₹' + n.toLocaleString('en-IN'); }

  function calcTotal() {
    var total = BOARDS[state.board].price;
    Object.keys(state.accessories).forEach(function (id) {
      if (state.accessories[id]) total += ACCESSORIES[id].price;
    });
    return total;
  }

  function accTotal() {
    var t = 0;
    Object.keys(state.accessories).forEach(function (id) {
      if (state.accessories[id]) t += ACCESSORIES[id].price;
    });
    return t;
  }

  function accCount() {
    return Object.keys(state.accessories).filter(function (id) { return state.accessories[id]; }).length;
  }

  /* ── UI UPDATES ────────────────────────────────────────────── */
  function updatePriceDisplay() {
    var total = calcTotal();
    var accT  = accTotal();
    var cnt   = accCount();
    var board = BOARDS[state.board];

    // Summary bar
    document.getElementById('sumBoardLabel').textContent = board.name;
    document.getElementById('sumBoardPrice').textContent = fmt(board.price);
    document.getElementById('sumTotal').textContent = fmt(total);
    document.getElementById('boardOnlyPrice').textContent = fmt(board.price);

    var accLine = document.getElementById('sumAccLine');
    if (cnt > 0) {
      accLine.style.display = '';
      document.getElementById('sumAccLabel').textContent = '+ ' + cnt + ' accessor' + (cnt === 1 ? 'y' : 'ies');
      document.getElementById('sumAccPrice').textContent = fmt(accT);
    } else {
      accLine.style.display = 'none';
    }

    // Add to cart button
    var btn = document.getElementById('addToCartBtn');
    if (cnt > 0) {
      btn.textContent = 'Add Complete Set to Cart — ' + fmt(total);
    } else {
      btn.textContent = 'Add Board to Cart — ' + fmt(board.price);
    }

    // Hero price
    document.getElementById('heroPrice').textContent = cnt > 0 ? fmt(total) : fmt(board.price);
    document.getElementById('heroPrice').previousElementSibling.textContent = cnt > 0 ? 'Total' : 'From';

    // Sticky bar
    document.getElementById('stickyPrice').textContent = fmt(total);
    var stickyBtn = document.querySelector('.sticky-bar .btn');
    if (stickyBtn) {
      stickyBtn.textContent = cnt > 0 ? 'Add to Cart — ' + fmt(total) : 'Configure Now ↓';
      stickyBtn.onclick = cnt > 0 ? function () { addToCart(true); } : scrollToConfigurator;
    }
  }

  /* ── BOARD SELECTION ───────────────────────────────────────── */
  window.selectBoard = function (boardId) {
    state.board = boardId;
    document.querySelectorAll('.board-card').forEach(function (card) {
      card.classList.toggle('is-selected', card.dataset.board === boardId);
    });
    // Swap hero image to match board
    var heroImg = document.getElementById('heroMainImg');
    if (heroImg) heroImg.src = BOARDS[boardId].img;
    updatePriceDisplay();
  };

  /* ── ACCESSORY TOGGLE ──────────────────────────────────────── */
  window.toggleAccessory = function (accId) {
    state.accessories[accId] = !state.accessories[accId];
    var card = document.querySelector('.acc-card[data-acc="' + accId + '"]');
    if (card) card.classList.toggle('is-selected', !!state.accessories[accId]);
    updatePriceDisplay();
  };

  /* ── BUNDLE APPLY ──────────────────────────────────────────── */
  window.applyBundle = function (bundleId) {
    var bundle = BUNDLES[bundleId];
    if (!bundle) return;

    // Reset accessories
    Object.keys(state.accessories).forEach(function (id) { state.accessories[id] = false; });
    document.querySelectorAll('.acc-card').forEach(function (c) { c.classList.remove('is-selected'); });

    // Set board
    selectBoard(bundle.board);

    // Set accessories
    bundle.accs.forEach(function (accId) {
      state.accessories[accId] = true;
      var card = document.querySelector('.acc-card[data-acc="' + accId + '"]');
      if (card) card.classList.add('is-selected');
    });

    updatePriceDisplay();

    // Smooth scroll to summary
    var bar = document.getElementById('summaryBar');
    if (bar) bar.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  };

  /* ── ADD TO CART (prototype) ───────────────────────────────── */
  window.addToCart = function (withAccessories) {
    var total = withAccessories ? calcTotal() : BOARDS[state.board].price;
    showToast('✓ Added to cart — ' + fmt(total));
    // Shopify: replace with actual cart API call
    // fetch('/cart/add.js', { method: 'POST', ... })
    if (typeof fbq !== 'undefined') {
      fbq('track', 'AddToCart', {
        content_name: BOARDS[state.board].name,
        content_category: 'Pegboards',
        value: total,
        currency: 'INR'
      });
    }
  };

  /* ── TOAST ─────────────────────────────────────────────────── */
  function showToast(msg) {
    var t = document.getElementById('toast');
    t.textContent = msg;
    t.classList.add('is-visible');
    setTimeout(function () { t.classList.remove('is-visible'); }, 3000);
  }

  /* ── SCROLL HELPERS ────────────────────────────────────────── */
  window.scrollToConfigurator = function () {
    document.getElementById('configurator').scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
  window.scrollToSection = function (id) {
    var el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  /* ── STICKY BAR ────────────────────────────────────────────── */
  var stickyBar = document.getElementById('stickyBar');
  var atcBtn = document.getElementById('addToCartBtn');
  window.addEventListener('scroll', function () {
    var scrollY = window.scrollY || window.pageYOffset;
    // Hide only when the real Add to Cart button is visible on screen
    var atcVisible = false;
    if (atcBtn) {
      var rect = atcBtn.getBoundingClientRect();
      atcVisible = rect.top < window.innerHeight && rect.bottom > 0;
    }
    stickyBar.classList.toggle('is-visible', scrollY > 400 && !atcVisible);
  }, { passive: true });

  /* ── HERO THUMBS ───────────────────────────────────────────── */
  document.querySelectorAll('.hero__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('.hero__thumb').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      var heroImg = document.getElementById('heroMainImg');
      if (heroImg && thumb.dataset.img) heroImg.src = thumb.dataset.img;
    });
  });

  /* ── REVIEW FILTER ─────────────────────────────────────────── */
  window.filterReviews = function (filter, tab) {
    document.querySelectorAll('.filter-tab').forEach(function (t) { t.classList.remove('is-active'); });
    tab.classList.add('is-active');
    document.querySelectorAll('.review-card').forEach(function (card) {
      var tags = card.dataset.tags || '';
      card.style.display = (filter === 'all' || tags.indexOf(filter) > -1) ? '' : 'none';
    });
  };

  /* ── REVIEW READ MORE ──────────────────────────────────────── */
  window.toggleReview = function (el) {
    var text = el.previousElementSibling;
    var isExpanded = text.classList.contains('is-clamped');
    text.classList.toggle('is-clamped', !isExpanded);
    el.textContent = isExpanded ? 'Show less' : 'Read more';
  };

  // Clamp reviews by default
  document.querySelectorAll('.review-text--clampable').forEach(function (t) { t.classList.add('is-clamped'); });

  /* ── LOAD MORE REVIEWS (stub) ──────────────────────────────── */
  window.loadMoreReviews = function (btn) {
    btn.textContent = 'All reviews shown';
    btn.disabled = true;
    // REPLACE: fetch more reviews from Shopify
  };

  /* ── FAQ ACCORDION ─────────────────────────────────────────── */
  window.toggleFaq = function (item) {
    var isOpen = item.classList.contains('is-open');
    document.querySelectorAll('.faq-item').forEach(function (f) { f.classList.remove('is-open'); });
    if (!isOpen) item.classList.add('is-open');
  };

  /* ── WHATSAPP ──────────────────────────────────────────────── */
  var WA_NUMBER = '919731815452';

  function buildWhatsAppMessage() {
    var board = BOARDS[state.board];
    var selectedAccs = Object.keys(state.accessories).filter(function (id) { return state.accessories[id]; });
    var lines = [];
    lines.push('Hi! I came across the Lila Grow Pegboard and I\'m interested.');
    lines.push('');
    lines.push('My current selection:');
    lines.push('📋 Board: ' + board.name + ' — ' + fmt(board.price));
    if (selectedAccs.length > 0) {
      selectedAccs.forEach(function (id) {
        lines.push('➕ ' + ACCESSORIES[id].name + ' — ' + fmt(ACCESSORIES[id].price));
      });
      lines.push('');
      lines.push('💰 Estimated total: ' + fmt(calcTotal()));
    } else {
      lines.push('');
      lines.push('(No accessories selected yet)');
    }
    lines.push('');
    lines.push('I have a question:');
    return lines.join('\n');
  }

  window.openWhatsApp = function (e) {
    e.preventDefault();
    var msg = buildWhatsAppMessage();
    var url = 'https://api.whatsapp.com/send?phone=' + WA_NUMBER + '&text=' + encodeURIComponent(msg);
    window.open(url, '_blank', 'noopener');
  };

  /* ── INIT ──────────────────────────────────────────────────── */
  updatePriceDisplay();

})();
